export default "https://svelte-store-server.herokuapp.com";
